import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import {
  selectAllLanguages,
  selectCurrentLangId,
  toLanguage,
  selectNav
} from '../features/languages/languagesSlice'

const root = process.env.PUBLIC_URL

const Navbar = () => {
  const nav = useSelector(selectNav)
  const [openMenu, SetOpenMenu] = useState(false)
  const location = useLocation()
  const dispatch = useDispatch()

  const handleClick__MenuOpen = () => SetOpenMenu(true)
  const handleClick__MenuClose = () => SetOpenMenu(false)

  const handleClick__BtnLanguageMenu = () => {
    setLangCollapse(!langCollapse)
  }
  const handleClick__BtnLanguage = (langId) => {
    setLangCollapse(!langCollapse)
    dispatch(toLanguage(langId))
  }

  const currLangId = useSelector(selectCurrentLangId)
  const [langCollapse, setLangCollapse] = useState(true)
  const languages = useSelector(selectAllLanguages)
  let renderedLangs = Object.values(languages).reduce((arr, lang) => {
    if (currLangId !== lang.id) {
      arr.push(<button key={lang.id} className={`btn ${langCollapse ? 'collapse' : ''}`} onClick={() => handleClick__BtnLanguage(lang.id)}>{lang.name}</button>)
    }
    return arr
  }, [])
  renderedLangs.unshift(<button key="@" className="btn active" onClick={handleClick__BtnLanguageMenu}>{languages[currLangId].type}</button>)
  
  return (
    <nav className="nav container">
      <Link to={`${root}/`} className="nav__logo">
        <img src={`${root}/assets/logo.svg`} alt="logo" className="nav__logo-img" />
        VOCAFLIP
      </Link>

      <div className={`nav__menu ${openMenu ? 'show-menu' : ''}`}>
        <ul className="nav__list">
          <li className="nav__item">
            <Link
              to={`${root}/`}
              className={`nav__link ${location.pathname === '/' ? 'active-link' : ''}`}
              onClick={handleClick__MenuClose}
            >
              {nav.home}
            </Link>
          </li>
          <li className="nav__item">
            <Link
              to={`${root}/about`}
              className={`nav__link ${location.pathname === '/about' ? 'active-link' : ''}`}
              onClick={handleClick__MenuClose}
            >
              {nav.about}
            </Link>
          </li>
          <li className="nav__item">
            <div className="lang-control">{renderedLangs}</div>
          </li>
        </ul>

        <div className="nav__close" onClick={handleClick__MenuClose}>X</div>
      </div>

      <div className="nav__toggle" onClick={handleClick__MenuOpen}>
        |||
      </div>
    </nav>
  )
}

export default Navbar